// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2-Y7c","col":"styles_col__2XHWG"};